// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"221":"aa68a192","248":"997c37d5","254":"325e09d0","273":"5c49db4a","296":"eb16c46e","363":"c19e03b4","437":"05264b6d","477":"9eb38fbc","820":"2a45c379","831":"e3bf496e","985":"8ec11ad4"}[chunkId] + ".chunk.js";
};